import { SocialAssociationViewModel } from '@apis/model/socialAssociation/SocialAssociationViewModel';
import { SocialAssociationResponse } from '@ul/api';

export const toSocialAssociationViewModel = (response: SocialAssociationResponse): SocialAssociationViewModel => {
    const { success, statusCode, message } = response;
    return {
        success,
        statusCode,
        message,
    };
};
